import {
  TextInput,
  ImageInput,
  SimpleForm,
  SelectInput,
  DateInput,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  AutocompleteInput,
  NumberInput,
} from 'react-admin'
import Grid from '@mui/material/Grid'

import CustomImageField from '../../components/CustomImageField'
import BookToolbar from '../../components/BookToolbar'
import { validateRequired } from '../../utils/validate'
import GridContainer from '../../components/GridContainer'
import { BOOK_STATUSES } from '../../components/constants'

const enableOptions = [
  { id: true, name: 'true' },
  { id: false, name: 'false' },
]

const CampaignForm = ({ ...props }) => {
  return (
    <SimpleForm
      {...props}
      toolbar={<BookToolbar />}
      redirect="list"
      variant="standard"
      margin="normal">
      <GridContainer>
        <Grid item xs={12}>
          <TextInput
            label="Campaign name"
            source="name"
            resettable
            fullWidth
            variant="standard"
            multiline
            validate={validateRequired('Campaign name')}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectInput
            label="Enable"
            source="status"
            choices={enableOptions}
            fullWidth
            variant="standard"
            required
            validate={validateRequired('Enable')}
          />
        </Grid>
        <Grid item xs={4}>
          <NumberInput name="quantity" source="quantity" />
        </Grid>
        <Grid item xs={4}>
          <TextInput name="code" source="code" disabled />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            source="description"
            resettable
            rows={5}
            fullWidth
            variant="standard"
            multiline
          />
        </Grid>

        <Grid item xs={6}>
          <DateInput
            source="startDate"
            fullWidth
            variant="standard"
            validate={validateRequired('startDate')}></DateInput>
        </Grid>
        <Grid item xs={6}>
          <DateInput
            source="endDate"
            fullWidth
            variant="standard"
            validate={validateRequired('endDate')}></DateInput>
        </Grid>

        {/* <------ Bg Image - Phone --------> */}
        <Grid item xs={12}>
          <ImageInput
            accept="image/*"
            source="bannerInfo.bgImagePhone.url"
            label="Bg Image (phone)"
            multiple={false}
            validate={validateRequired('Bg Image (phone)')}>
            <CustomImageField
              originalSrc={false}
              source="src"
              title="Bg Image"
            />
          </ImageInput>
        </Grid>

        {/* <------ Bg image - Tablet --------> */}
        <Grid item xs={12}>
          <ImageInput
            accept="image/*"
            source="bannerInfo.bgImageTablet.url"
            label="Bg Image (tablet)"
            multiple={false}
            validate={validateRequired('Bg Image (tablet)')}>
            <CustomImageField
              originalSrc={false}
              source="src"
              title="Bg Image"
            />
          </ImageInput>
        </Grid>

        <Grid item xs={12}>
          <ArrayInput
            label="Books"
            source="books"
            fullWidth
            validate={[
              validateRequired('Books'),
              // validateUnique('bookId', true),
            ]}>
            <SimpleFormIterator>
              <TextInput
                source="order"
                label="Order"
                variant="standard"
                fullWidth={true}
              />
              <ReferenceInput
                label="Book"
                source={'id'}
                reference="books"
                filter={{
                  status: BOOK_STATUSES.PUBLISHED,
                }}
                rows={6}>
                <AutocompleteInput
                  optionText="title"
                  options={{
                    fullWidth: true,
                  }}
                  variant="standard"
                  filterToQuery={searchText => ({
                    title: { $iLike: `%${searchText}%` },
                    status: BOOK_STATUSES.PUBLISHED,
                  })}
                />
              </ReferenceInput>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>

        <Grid item xs={10}>
          <TextInput
            source="tagTitle"
            resettable
            fullWidth
            variant="standard"
          />
        </Grid>

        <Grid item xs={12}>
          <TextInput
            source="tagDescription"
            resettable
            rows={5}
            fullWidth
            variant="standard"
            multiline
          />
        </Grid>
      </GridContainer>
    </SimpleForm>
  )
}

export default CampaignForm
